import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Breadcrumbs from 'react-router-dynamic-breadcrumbs'
import { Link, withRouter } from 'react-router-dom'
import axios from 'axios'
import routes from '../config/routes'

const Container = styled.div`
  margin: 10px 0;
  padding: 10px;
  background-color: #f5f5f5;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  ol.crumbs {
    margin: 0;
    padding: 0;
    list-style-type: none;
    li {
      display: inline-block;
      text-transform: uppercase;
      &:not(:first-child)::before {
        content: '/';
        padding: 0 5px;
        color: #ccc;
      }
    }
  }
`

const Header = ({ location, match }) => {
  const [jnlEnd, setJnlEnd] = useState()

  useEffect(() => {
    const getJnlEnd = async () => {
      const result = await axios.get('/JournalDates')
      setJnlEnd(result.data[0].end.trim())
    }
    getJnlEnd()
  }, [])

  return (
    <Container>
      <Breadcrumbs
        mappedRoutes={routes}
        WrapperComponent={props => <ol className="crumbs">{props.children}</ol>}
        ActiveLinkComponent={props => (
          <li className="active">{props.children.replace('%20', ' ')}</li>
        )}
        LinkComponent={props => (
          <li>
            <Link
              {...props.children.props}
              to={props.children.props.to + location.search}
            >
              {props.children.props.children.replace('%20', ' ')}
            </Link>
            {/* {React.cloneElement(props.children, {
            to: location.search
          })} */}
          </li>
        )}
      />
      <div>
        FISCAL YEAR {match.params.year}
        {match.params.year === '2020' && <span> (through {jnlEnd})</span>}
      </div>
    </Container>
  )
}

export default withRouter(Header)
